export default __webpack_public_path__ + "static/media/SUTA-Rate-Template.312e7370.csv";